// extracted by mini-css-extract-plugin
module.exports = {"isi":"ISIFooter_isi__3c6Ki","alternative":"ISIFooter_alternative__ow7Hy"};